import React from "react";

const PaymentsIcon = ({ color = "#0A61F5" }) => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.68457 8.18427C6.68457 8.93804 6.98401 9.66094 7.517 10.1939C8.05 10.7269 8.7729 11.0264 9.52668 11.0264C10.2804 11.0264 11.0033 10.7269 11.5363 10.1939C12.0693 9.66094 12.3688 8.93804 12.3688 8.18427C12.3688 7.4305 12.0693 6.70759 11.5363 6.1746C11.0033 5.6416 10.2804 5.34216 9.52668 5.34216C8.7729 5.34216 8.05 5.6416 7.517 6.1746C6.98401 6.70759 6.68457 7.4305 6.68457 8.18427Z"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.52632 13.8684H2.89474C2.39222 13.8684 1.91029 13.6688 1.55496 13.3135C1.19962 12.9581 1 12.4762 1 11.9737V4.39474C1 3.89222 1.19962 3.41029 1.55496 3.05496C1.91029 2.69962 2.39222 2.5 2.89474 2.5H16.1579C16.6604 2.5 17.1423 2.69962 17.4977 3.05496C17.853 3.41029 18.0526 3.89222 18.0526 4.39474V8.65789M15.2105 8.18421H15.22M3.84211 8.18421H3.85158M13.3158 14.8158H19M13.3158 14.8158L16.1579 11.9737M13.3158 14.8158L16.1579 17.6579"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default PaymentsIcon;
